module.exports = __webpack_public_path__ + "static/14-712857c41ce4761f17bb50ef849c12f6.jpg";